export default __webpack_public_path__ + "static/door-08f0145dd7d858bedc84537528761e36.png";